/**
 * Created by Arif Topcu in 2019
 */

import React, { useCallback } from "react";
import BetasSelectorComplication from "./BetasSelectorComplication";
import ComplicationSelector from "@ls/grouping-complication-selector";
import { useDispatch, useSelector } from "react-redux";
import SelectionState from "state/selections/SelectionState";
import { setDefinition as setBetaDefinition } from "state/betas/actions";
import BetaDefinition from "state/betas/BetaDefinition";
import { selectDefinitions } from "state/betas/selectors";

const BetaSelector = () => {
  const dispatch = useDispatch();
  const definitions = useSelector(
    selectDefinitions(SelectionState.UNCOMMITTED)
  );
  const setDefinition = useCallback(
    (definitions, idx) => dispatch(setBetaDefinition(definitions, idx)),
    [dispatch]
  );

  return (
    <ComplicationSelector
      selectedDefinitions={definitions}
      setDefinition={setDefinition}
      getDefaultDefinition={BetaDefinition.getDefault}
      ComplicationComponent={BetasSelectorComplication}
      btnTitle={"Betas"}
      addMoreText={"Beta Column"}
    />
  );
};

export default BetaSelector;
